module.exports = __webpack_public_path__ + "img/service-team.8a7629b7.jpg";